import { Controller } from "@hotwired/stimulus"
// Available options via data attributes:
//   data-tomselect-plugins-value='["remove_button", "clear_button"]'
//   data-tomselect-max-items-value="null" (for multiple selection)
//   data-tomselect-create-value="true" (allow creating new items)
//   data-tomselect-placeholder-value="Select an option"

export default class extends Controller {
  static values = {
    plugins: { type: Array, default: [] },
    maxItems: { type: String, default: 'null' },
    create: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    allOption: { type: Boolean, default: false }
  }

  connect() {
    this.initTomSelect()

    // If allOption is enabled, intercept form submission to clean up 'all' value
    if (this.allOptionValue) {
      this.form = this.element.closest('form')
      if (this.form) {
        this.boundHandleSubmit = this.handleSubmit.bind(this)
        this.form.addEventListener('submit', this.boundHandleSubmit)
      }
    }
  }

  disconnect() {
    if (this.tomselect) {
      this.tomselect.destroy()
    }

    // Clean up form event listener
    if (this.form && this.boundHandleSubmit) {
      this.form.removeEventListener('submit', this.boundHandleSubmit)
    }
  }

  initTomSelect() {
    const options = {}

    // Add plugins
    if (this.pluginsValue.length > 0) {
      options.plugins = this.pluginsValue
    }

    // Set max items (null for unlimited in multiple select)
    if (this.maxItemsValue === 'null') {
      options.maxItems = null
    } else {
      options.maxItems = parseInt(this.maxItemsValue, 10)
    }

    // Enable creation of new items
    if (this.createValue) {
      options.create = true
    }

    if (this.placeholderValue) {
      options.placeholder = this.placeholderValue
    }

    // Handle "All" option behavior
    if (this.allOptionValue) {
      options.onItemAdd = (value) => this.handleAllOption(value)
    }

    this.tomselect = new TomSelect(this.element, options)
  }

  handleAllOption(value) {
    const items = this.tomselect.items

    // If "all" is selected, remove all other selections
    if (value === 'all') {
      const otherItems = items.filter(item => item !== 'all')
      otherItems.forEach(item => {
        this.tomselect.removeItem(item, true) // silent = true to prevent triggering events
      })
    } else {
      // If any specific organisation is selected, remove "all"
      if (items.includes('all')) {
        this.tomselect.removeItem('all', true)
      }
    }
  }

  handleSubmit(event) {
    // If 'all' is selected, clear the select entirely before submission
    // This will submit an empty array, which the backend interprets as "visible to all"
    const items = this.tomselect.items
    if (items.includes('all')) {
      this.tomselect.clear(true) // silent = true to prevent triggering events
    }
  }
}
